import http from '@/httpCommon/axiosClient';

class CustomerCardService {
    findCardNo = async (cardNo: string) => {
        const res = await http.get(`/customer-card/${cardNo}`);
        return res?.data;
    };

    detail = async (customerCardId: string) => {
        const res = await http.get(`/customer-card/detail/${customerCardId}`);
        return res?.data;
    };
}
export default new CustomerCardService();
